// import * as apis from '@apis'

const video = {
  namespaced: true,
  state: {
    metadata: {
      'mod': 'video'
    },
    censorshipTableData: {},
    issuesData: {}
  },
  getters: {},
  mutations: {},
  actions: {}
}

export default video
